import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
const LavenderSVG1 = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 120 350" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-268" data-mp="1gpqigpef4k40">
    <path d="M60 350 Q70 200 30 30" stroke="#8B9D77" strokeWidth="2.5" strokeLinecap="round" data-id="element-269" data-mp="11sg9bmp8zqbg" />
    <path d="M63 300 Q85 280 90 250 Q70 270 61 290" fill="#8B9D77" opacity="0.7" data-id="element-270" data-mp="16qrn28inykyy" />
    <path d="M57 250 Q35 230 30 200 Q50 220 59 240" fill="#8B9D77" opacity="0.7" data-id="element-271" data-mp="szmrbhif2ctw" />
    <path d="M65 180 Q85 160 90 130 Q70 150 63 170" fill="#8B9D77" opacity="0.7" data-id="element-272" data-mp="xrwg2u7sp6ul" />
    <g opacity="0.85" data-id="element-273" data-mp="j2qgv68yjgmp">
      <ellipse cx="45" cy="140" rx="4" ry="6" fill="#a78bfa" transform="rotate(20 45 140)" data-id="element-274" data-mp="j39onu4w8on0" />
      <ellipse cx="52" cy="135" rx="3" ry="5" fill="#c084fc" transform="rotate(-15 52 135)" data-id="element-275" data-mp="o11n7701n906" />
      <ellipse cx="55" cy="120" rx="4.5" ry="7" fill="#c084fc" transform="rotate(-25 55 120)" data-id="element-276" data-mp="a1a6uzm21gj0" />
      <ellipse cx="48" cy="115" rx="3.5" ry="5" fill="#d8b4fe" transform="rotate(10 48 115)" data-id="element-277" data-mp="e3x1f8a41fjw" />
      <ellipse cx="40" cy="100" rx="3.5" ry="6" fill="#d8b4fe" transform="rotate(30 40 100)" data-id="element-278" data-mp="3uynbx5p5i0rz" />
      <ellipse cx="47" cy="95" rx="4" ry="6" fill="#a78bfa" transform="rotate(-10 47 95)" data-id="element-279" data-mp="3q02knvrvmrfo" />
      <ellipse cx="50" cy="80" rx="5" ry="8" fill="#a78bfa" transform="rotate(-20 50 80)" data-id="element-280" data-mp="8roznzukoh5v" />
      <ellipse cx="42" cy="75" rx="3" ry="5" fill="#c084fc" transform="rotate(15 42 75)" data-id="element-281" data-mp="8pck1tcaeivz" />
      <ellipse cx="35" cy="60" rx="4" ry="6" fill="#c084fc" transform="rotate(25 35 60)" data-id="element-282" data-mp="3qrkzx8ru594" />
      <ellipse cx="42" cy="55" rx="3.5" ry="5" fill="#d8b4fe" transform="rotate(-5 42 55)" data-id="element-283" data-mp="3c6bb4ne5b7jy" />
      <ellipse cx="45" cy="40" rx="4.5" ry="7" fill="#a78bfa" transform="rotate(-30 45 40)" data-id="element-284" data-mp="37b5plponnuwe" />
      <ellipse cx="38" cy="35" rx="3" ry="5" fill="#c084fc" transform="rotate(10 38 35)" data-id="element-285" data-mp="3lzjq3tyln79s" />
      <ellipse cx="30" cy="25" rx="3.5" ry="5" fill="#d8b4fe" transform="rotate(20 30 25)" data-id="element-286" data-mp="3h5xpj05pmtuc" />
      <ellipse cx="35" cy="20" rx="2.5" ry="4" fill="#a78bfa" transform="rotate(-15 35 20)" data-id="element-287" data-mp="2tgms9snkjhky" />
    </g>
  </svg>;
const LavenderSVG2 = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 150 300" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-288" data-mp="3e7s2ihgolz8o">
    <path d="M75 300 Q60 150 90 20" stroke="#8B9D77" strokeWidth="2" strokeLinecap="round" data-id="element-289" data-mp="3i7sgy23s6afq" />
    <path d="M70 200 Q40 150 30 80" stroke="#8B9D77" strokeWidth="1.5" strokeLinecap="round" data-id="element-290" data-mp="3mz0rj1guk1uh" />
    <path d="M73 260 Q50 250 40 220 Q60 240 71 250" fill="#8B9D77" opacity="0.7" data-id="element-291" data-mp="3rywvj0pjnta1" />
    <path d="M74 180 Q100 170 110 140 Q90 160 76 170" fill="#8B9D77" opacity="0.7" data-id="element-292" data-mp="2v8e5trrkiaeh" />
    <g opacity="0.85" data-id="element-293" data-mp="2vah6r6u9dnxz">
      {/* Main Stem Flowers */}
      <ellipse cx="80" cy="120" rx="4" ry="6" fill="#c084fc" transform="rotate(-15 80 120)" data-id="element-294" data-mp="2zahiuktvxn1v" />
      <ellipse cx="88" cy="115" rx="3" ry="5" fill="#a78bfa" transform="rotate(20 88 115)" data-id="element-295" data-mp="347rkcyujtp62" />
      <ellipse cx="90" cy="100" rx="4.5" ry="7" fill="#a78bfa" transform="rotate(25 90 100)" data-id="element-296" data-mp="398xaqq0ql0cf" />
      <ellipse cx="82" cy="95" rx="3.5" ry="5" fill="#d8b4fe" transform="rotate(-10 82 95)" data-id="element-297" data-mp="jjda2nv47f5j" />
      <ellipse cx="75" cy="80" rx="3.5" ry="6" fill="#d8b4fe" transform="rotate(-25 75 80)" data-id="element-298" data-mp="ogvjsggyhyel" />
      <ellipse cx="83" cy="75" rx="4" ry="6" fill="#c084fc" transform="rotate(15 83 75)" data-id="element-299" data-mp="2908tugzrxqw7" />
      <ellipse cx="85" cy="60" rx="5" ry="8" fill="#c084fc" transform="rotate(20 85 60)" data-id="element-300" data-mp="2402ueen9j03k" />
      <ellipse cx="77" cy="55" rx="3" ry="5" fill="#a78bfa" transform="rotate(-20 77 55)" data-id="element-301" data-mp="1z9mgktfj5cgo" />
      <ellipse cx="95" cy="40" rx="4" ry="6" fill="#a78bfa" transform="rotate(30 95 40)" data-id="element-302" data-mp="1uat14vgonbdv" />
      <ellipse cx="87" cy="35" rx="3.5" ry="5" fill="#d8b4fe" transform="rotate(-5 87 35)" data-id="element-303" data-mp="1u8ypk7rawvmg" />
      <ellipse cx="88" cy="20" rx="3" ry="5" fill="#d8b4fe" transform="rotate(15 88 20)" data-id="element-304" data-mp="1q6v2smz6m4lv" />

      {/* Side Stem Flowers */}
      <ellipse cx="45" cy="140" rx="3.5" ry="5" fill="#a78bfa" transform="rotate(-20 45 140)" data-id="element-305" data-mp="1garzhdslfzxc" />
      <ellipse cx="38" cy="135" rx="2.5" ry="4" fill="#d8b4fe" transform="rotate(15 38 135)" data-id="element-306" data-mp="1bc6z9edcdg8w" />
      <ellipse cx="35" cy="120" rx="4" ry="6" fill="#d8b4fe" transform="rotate(-30 35 120)" data-id="element-307" data-mp="3ap2ts1ryjmai" />
      <ellipse cx="42" cy="115" rx="3" ry="5" fill="#c084fc" transform="rotate(10 42 115)" data-id="element-308" data-mp="35pyhh29ql8fy" />
      <ellipse cx="40" cy="100" rx="3" ry="5" fill="#c084fc" transform="rotate(-15 40 100)" data-id="element-309" data-mp="35o57bczx0637" />
      <ellipse cx="33" cy="95" rx="2.5" ry="4" fill="#a78bfa" transform="rotate(25 33 95)" data-id="element-310" data-mp="3dotfju71s266" />
      <ellipse cx="28" cy="80" rx="3.5" ry="5" fill="#a78bfa" transform="rotate(-25 28 80)" data-id="element-311" data-mp="3ino5dg3fmqzs" />
    </g>
  </svg>;
const LavenderSVG3 = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 100 250" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-312" data-mp="38q01o0num95h">
    <path d="M50 250 Q55 120 45 10" stroke="#8B9D77" strokeWidth="2.5" strokeLinecap="round" data-id="element-313" data-mp="2uylinttxy7yf" />
    <path d="M51 200 Q70 190 75 160 Q60 180 52 190" fill="#8B9D77" opacity="0.7" data-id="element-314" data-mp="2zsfwwhqs1uq4" />
    <path d="M49 150 Q30 140 25 110 Q40 130 48 140" fill="#8B9D77" opacity="0.7" data-id="element-315" data-mp="2l31ll43n5383" />
    <g opacity="0.9" data-id="element-316" data-mp="2q0juwvlklkgm">
      <ellipse cx="40" cy="90" rx="4" ry="6" fill="#a78bfa" transform="rotate(-20 40 90)" data-id="element-317" data-mp="2q1v1f36eh6bf" />
      <ellipse cx="48" cy="88" rx="3" ry="5" fill="#c084fc" transform="rotate(15 48 88)" data-id="element-318" data-mp="2c2d8qcpzh8ws" />
      <ellipse cx="55" cy="85" rx="5" ry="7" fill="#c084fc" transform="rotate(25 55 85)" data-id="element-319" data-mp="2g35l3eu5jtxa" />
      <ellipse cx="47" cy="80" rx="3.5" ry="5" fill="#d8b4fe" transform="rotate(-10 47 80)" data-id="element-320" data-mp="1xdtnwvgjt1ls" />
      <ellipse cx="45" cy="75" rx="4.5" ry="6" fill="#d8b4fe" transform="rotate(-15 45 75)" data-id="element-321" data-mp="1sg1w01fwlfhl" />
      <ellipse cx="52" cy="70" rx="3" ry="5" fill="#a78bfa" transform="rotate(20 52 70)" data-id="element-322" data-mp="26ft63r3aubqb" />
      <ellipse cx="35" cy="65" rx="3.5" ry="5" fill="#a78bfa" transform="rotate(-30 35 65)" data-id="element-323" data-mp="21ggl7bvzneqd" />
      <ellipse cx="43" cy="62" rx="2.5" ry="4" fill="#c084fc" transform="rotate(10 43 62)" data-id="element-324" data-mp="2gdhcxfe6j9ou" />
      <ellipse cx="52" cy="60" rx="4" ry="6" fill="#c084fc" transform="rotate(20 52 60)" data-id="element-325" data-mp="2bee7vuy793gv" />
      <ellipse cx="45" cy="55" rx="3" ry="5" fill="#a78bfa" transform="rotate(-15 45 55)" data-id="element-326" data-mp="2bcjwb78tinpg" />
      <ellipse cx="42" cy="50" rx="5" ry="7" fill="#a78bfa" transform="rotate(-25 42 50)" data-id="element-327" data-mp="2p7vop7zi4237" />
      <ellipse cx="50" cy="45" rx="3.5" ry="5" fill="#d8b4fe" transform="rotate(15 50 45)" data-id="element-328" data-mp="2l4zbxxwn7076" />
      <ellipse cx="50" cy="40" rx="3.5" ry="5" fill="#d8b4fe" transform="rotate(20 50 40)" data-id="element-329" data-mp="2z48kcbelwq0l" />
      <ellipse cx="42" cy="35" rx="2.5" ry="4" fill="#c084fc" transform="rotate(-10 42 35)" data-id="element-330" data-mp="2u6ffpmsyc42f" />
      <ellipse cx="38" cy="30" rx="4" ry="6" fill="#c084fc" transform="rotate(-30 38 30)" data-id="element-331" data-mp="1rt114u1fxnnc" />
      <ellipse cx="45" cy="25" rx="3" ry="5" fill="#a78bfa" transform="rotate(15 45 25)" data-id="element-332" data-mp="1vturrv69pgjx" />
      <ellipse cx="48" cy="20" rx="3" ry="5" fill="#a78bfa" transform="rotate(25 48 20)" data-id="element-333" data-mp="20r37zq7uvaij" />
      <ellipse cx="43" cy="10" rx="2.5" ry="4" fill="#d8b4fe" transform="rotate(-15 43 10)" data-id="element-334" data-mp="25j4lffgrf7a5" />
    </g>
  </svg>;
export function LavenderBranches() {
  const {
    scrollYProgress
  } = useScroll();
  // Different parallax speeds for depth
  const y1 = useTransform(scrollYProgress, [0, 1], [0, -150]);
  const y2 = useTransform(scrollYProgress, [0, 1], [0, -250]);
  const y3 = useTransform(scrollYProgress, [0, 1], [0, -100]);
  const y4 = useTransform(scrollYProgress, [0, 1], [0, -300]);
  return <div className="fixed inset-y-0 left-0 right-0 z-[2] pointer-events-none hidden xl:block overflow-hidden" data-id="element-335" data-mp="p5edfxmiryv8">
      {/* Left side branches */}
      <motion.div style={{
      y: y1
    }} className="absolute top-[10%] -left-10 w-48 opacity-60 blur-[0.5px]" data-id="element-336" data-mp="u5s9ehaujicw">
        <motion.div animate={{
        rotate: [-2, 2, -2]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="origin-bottom" data-id="element-337" data-mp="mlzqnvqra3lf">
          <LavenderSVG1 className="w-full h-auto" data-id="element-338" data-mp="cs0tlb5jha0c" />
        </motion.div>
      </motion.div>

      <motion.div style={{
      y: y2
    }} className="absolute top-[40%] -left-16 w-64 opacity-40 blur-[1px]" data-id="element-339" data-mp="7t7gvky2tn18">
        <motion.div animate={{
        rotate: [1, -2, 1]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="origin-bottom" data-id="element-340" data-mp="10jy674gtc62i">
          <LavenderSVG2 className="w-full h-auto" data-id="element-341" data-mp="vmplox86zpy3" />
        </motion.div>
      </motion.div>

      <motion.div style={{
      y: y3
    }} className="absolute top-[75%] -left-6 w-40 opacity-70" data-id="element-342" data-mp="rlcdwhljhcoj">
        <motion.div animate={{
        rotate: [-1, 3, -1]
      }} transition={{
        duration: 9,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="origin-bottom" data-id="element-343" data-mp="3g8zl26bb80ou">
          <LavenderSVG3 className="w-full h-auto" data-id="element-344" data-mp="1fayyvirkwiy0" />
        </motion.div>
      </motion.div>

      {/* Right side branches (mirrored) */}
      <motion.div style={{
      y: y4
    }} className="absolute top-[5%] -right-12 w-56 opacity-50 blur-[0.5px] scale-x-[-1]" data-id="element-345" data-mp="168g13d2ngwim">
        <motion.div animate={{
        rotate: [-2, 2, -2]
      }} transition={{
        duration: 11,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="origin-bottom" data-id="element-346" data-mp="1b82bler3fynq">
          <LavenderSVG2 className="w-full h-auto" data-id="element-347" data-mp="22xdvgu6hmsf9" />
        </motion.div>
      </motion.div>

      <motion.div style={{
      y: y1
    }} className="absolute top-[45%] -right-8 w-48 opacity-70 scale-x-[-1]" data-id="element-348" data-mp="1p7tw7yc48dap">
        <motion.div animate={{
        rotate: [2, -1, 2]
      }} transition={{
        duration: 8.5,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="origin-bottom" data-id="element-349" data-mp="1u4u1w851ze1a">
          <LavenderSVG1 className="w-full h-auto" data-id="element-350" data-mp="2mnhgr5tghwtx" />
        </motion.div>
      </motion.div>

      <motion.div style={{
      y: y2
    }} className="absolute top-[80%] -right-16 w-64 opacity-40 blur-[1px] scale-x-[-1]" data-id="element-351" data-mp="2w06ix4v8dbcj">
        <motion.div animate={{
        rotate: [-3, 1, -3]
      }} transition={{
        duration: 12,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="origin-bottom" data-id="element-352" data-mp="2rze8w9ejb2f7">
          <LavenderSVG3 className="w-full h-auto" data-id="element-353" data-mp="30shtd1nlkfjc" />
        </motion.div>
      </motion.div>
    </div>;
}